export type ApiErrorsResponse = {
  errors?: Record<string, unknown>
  status?: string | null
  meta?: Record<string, unknown> | null
}

type ApiErrorsHandler = (response: ApiErrorsResponse) => void

let apiErrorsHandler: ApiErrorsHandler | null = null

export const setApiErrorsHandler = (handler: ApiErrorsHandler): void => {
  apiErrorsHandler = handler
}

export const notifyApiErrors = (response: ApiErrorsResponse): void => {
  apiErrorsHandler?.(response)
}
